webpackJsonp([20,157,158,159,236,237,294,295],{

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            checkbox: false,
            checkboxCustom: 'Yes'
        };
    }
});

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', [_vm._v("Basic")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.checkbox),
      callback: function($$v) {
        _vm.checkbox = $$v
      },
      expression: "checkbox"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.checkbox) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "true-value": "Yes",
      "false-value": "No"
    },
    model: {
      value: (_vm.checkboxCustom),
      callback: function($$v) {
        _vm.checkboxCustom = $$v
      },
      expression: "checkboxCustom"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.checkboxCustom) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "indeterminate": true
    }
  }, [_vm._v("\n                Indeterminate\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            checkboxGroup: ['Flint']
        };
    }
});

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-checkbox', {
    attrs: {
      "native-value": "Silver"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Silver\n            ")]), _vm._v(" "), _c('b-checkbox', {
    attrs: {
      "native-value": "Flint"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Flint\n            ")]), _vm._v(" "), _c('b-checkbox', {
    attrs: {
      "native-value": "Vane"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Vane\n            ")]), _vm._v(" "), _c('b-checkbox', {
    attrs: {
      "native-value": "Billy",
      "disabled": ""
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Billy\n            ")])], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selection:")]), _vm._v("\n            " + _vm._s(_vm.checkboxGroup) + "\n        ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "size": "is-small"
    }
  }, [_vm._v("Small")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', [_vm._v("Default")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "size": "is-medium"
    }
  }, [_vm._v("Medium")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "size": "is-large"
    }
  }, [_vm._v("Large")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n                Default\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "value": true,
      "type": "is-info"
    }
  }, [_vm._v("\n                Info\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "value": true,
      "type": "is-success"
    }
  }, [_vm._v("\n                Success\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "value": true,
      "type": "is-danger"
    }
  }, [_vm._v("\n                Danger\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "value": true,
      "type": "is-warning"
    }
  }, [_vm._v("\n                Warning\n            ")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            checkboxGroup: []
        };
    }
});

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-checkbox-button', {
    attrs: {
      "native-value": "Nope",
      "type": "is-danger"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Nope")])], 1), _vm._v(" "), _c('b-checkbox-button', {
    attrs: {
      "native-value": "Yep",
      "type": "is-success"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Yep")])], 1), _vm._v(" "), _c('b-checkbox-button', {
    attrs: {
      "native-value": "Default"
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Default\n            ")]), _vm._v(" "), _c('b-checkbox-button', {
    attrs: {
      "native-value": "Disabled",
      "disabled": ""
    },
    model: {
      value: (_vm.checkboxGroup),
      callback: function($$v) {
        _vm.checkboxGroup = $$v
      },
      expression: "checkboxGroup"
    }
  }, [_vm._v("\n                Disabled\n            ")])], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selection:")]), _vm._v("\n            " + _vm._s(_vm.checkboxGroup) + "\n        ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Checkbox',
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Any',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>native-value</code>',
        description: 'Same as native <code>value</code>',
        type: 'Any',
        values: '—',
        default: '—'
    }, {
        name: '<code>indeterminate</code>',
        description: 'Same as native <code>indeterminate</code>',
        type: 'Boolean',
        values: '—',
        default: '—'
    }, {
        name: '<code>true-value</code>',
        description: 'Overrides the returned value when it\'s checked',
        type: 'Any',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>false-value</code>',
        description: 'Overrides the returned value when it\'s not checked',
        type: 'Any',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Same as native <code>disabled</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>required</code>',
        description: 'Same as native <code>required</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>name</code>',
        description: 'Same as native <code>name</code>',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Size  of the control, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>type</code>',
        description: 'Type (color) of the control, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }],
    events: [{
        name: '<code>input</code>',
        description: 'Triggers when the value of checkbox is changed',
        parameters: '<code>value: Boolean</code>'
    }, {
        name: '<code>[any].native</code>',
        description: 'Listen to any event using this syntax, e.g <code>click.native</code>',
        parameters: '<code>event: $event</code>'
    }]
}, {
    title: 'Checkbox Button',
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Any',
        values: '—',
        default: '—'
    }, {
        name: '<code>native-value</code>',
        description: 'Same as native <code>value</code>',
        type: 'Any',
        values: '—',
        default: '—'
    }, {
        name: '<code>type</code>',
        description: 'Type (color) of the button <strong>when checked</strong>',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-primary</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Same as native <code>disabled</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>name</code>',
        description: 'Same as native <code>name</code>',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Size of the button, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>expanded</code>',
        description: 'Checkbox button will be expanded (full-width)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }]
}]);

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$checkbox-active-background-color</code>',
    default: '<code>$primary</code>'
}, {
    name: '<code>$checkbox-background-color</code>',
    default: '<code>transparent</code>'
}, {
    name: '<code>$checkbox-border-color</code>',
    default: '<code>$grey</code>'
}, {
    name: '<code>$checkbox-border-radius</code>',
    default: '<code>$radius</code>'
}, {
    name: '<code>$checkbox-border-width</code>',
    default: '<code>2px</code>'
}, {
    name: '<code>$checkbox-checkmark-color</code>',
    default: '<code>$primary-invert</code>'
}, {
    name: '<code>$checkbox-size</code>',
    default: '<code>1.25em</code>'
}]);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1002),
  /* template */
  __webpack_require__(1003),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1005),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1006),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1009),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_checkbox__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_checkbox__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExArray__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExArray__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExTypes__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExTypes__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExCheckboxButton__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExCheckboxButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExCheckboxButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCheckboxButton__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCheckboxButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCheckboxButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_checkbox__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_checkbox__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExArray: __WEBPACK_IMPORTED_MODULE_4__examples_ExArray___default.a,
            ExArrayCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExArray___default.a,
            ExSizes: __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default.a,
            ExSizesCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default.a,
            ExTypes: __WEBPACK_IMPORTED_MODULE_8__examples_ExTypes___default.a,
            ExTypesCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExTypes___default.a,
            ExCheckboxButton: __WEBPACK_IMPORTED_MODULE_10__examples_ExCheckboxButton___default.a,
            ExCheckboxButtonCode: __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCheckboxButton___default.a
        };
    }
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-checkbox>Basic</b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox v-model=\"checkbox\">\n                {{ checkbox }}\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox v-model=\"checkboxCustom\"\n                true-value=\"Yes\"\n                false-value=\"No\">\n                {{ checkboxCustom }}\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox :indeterminate=\"true\">\n                Indeterminate\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox disabled>Disabled</b-checkbox>\n        </div>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                checkbox: false,\n                checkboxCustom: 'Yes'\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"block\">\n            <b-checkbox v-model=\"checkboxGroup\"\n                native-value=\"Silver\">\n                Silver\n            </b-checkbox>\n            <b-checkbox v-model=\"checkboxGroup\"\n                native-value=\"Flint\">\n                Flint\n            </b-checkbox>\n            <b-checkbox v-model=\"checkboxGroup\"\n                native-value=\"Vane\">\n                Vane\n            </b-checkbox>\n            <b-checkbox v-model=\"checkboxGroup\"\n                native-value=\"Billy\" disabled>\n                Billy\n            </b-checkbox>\n        </div>\n        <p class=\"content\">\n            <b>Selection:</b>\n            {{ checkboxGroup }}\n        </p>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                checkboxGroup: ['Flint']\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1341:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-checkbox size=\"is-small\">Small</b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox>Default</b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox size=\"is-medium\">Medium</b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox size=\"is-large\">Large</b-checkbox>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1342:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-checkbox :value=\"true\">\n                Default\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox :value=\"true\"\n            type=\"is-info\">\n                Info\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox :value=\"true\"\n            type=\"is-success\">\n                Success\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox :value=\"true\"\n            type=\"is-danger\">\n                Danger\n            </b-checkbox>\n        </div>\n        <div class=\"field\">\n            <b-checkbox :value=\"true\"\n            type=\"is-warning\">\n                Warning\n            </b-checkbox>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field>\n            <b-checkbox-button v-model=\"checkboxGroup\"\n                native-value=\"Nope\"\n                type=\"is-danger\">\n                <b-icon icon=\"close\"></b-icon>\n                <span>Nope</span>\n            </b-checkbox-button>\n\n            <b-checkbox-button v-model=\"checkboxGroup\"\n                native-value=\"Yep\"\n                type=\"is-success\">\n                <b-icon icon=\"check\"></b-icon>\n                <span>Yep</span>\n            </b-checkbox-button>\n\n            <b-checkbox-button v-model=\"checkboxGroup\"\n                native-value=\"Default\">\n                Default\n            </b-checkbox-button>\n\n            <b-checkbox-button v-model=\"checkboxGroup\"\n                native-value=\"Disabled\"\n                disabled>\n                Disabled\n            </b-checkbox-button>\n        </b-field>\n        <p class=\"content\">\n            <b>Selection:</b>\n            {{ checkboxGroup }}\n        </p>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                checkboxGroup: []\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExArray,
      "code": _vm.ExArrayCode,
      "title": "Grouped (Array)",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Just add the same "), _c('code', [_vm._v("v-model")]), _vm._v(" to multiple Checkboxes, and set a "), _c('code', [_vm._v("native-value")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypes,
      "code": _vm.ExTypesCode,
      "title": "Types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCheckboxButton,
      "code": _vm.ExCheckboxButtonCode,
      "title": "Checkbox Button"
    }
  }, [_c('p', [_vm._v("You have to wrap them on a "), _c('router-link', {
    attrs: {
      "to": "/documentation/field"
    }
  }, [_vm._v("Field")]), _vm._v(".")], 1)]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1338),
  /* template */
  __webpack_require__(1344),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/20.95b8cfd15ea2c1f426cd.js